// extracted by mini-css-extract-plugin
export default {"container":"styles_container__AHAJm","button":"styles_button__ATUgV","leftButton":"styles_leftButton__AcmQr","rightButton":"styles_rightButton__ye2y5","input":"styles_input__IePit"};